import { render, staticRenderFns } from "./SimulatorDebugView.vue?vue&type=template&id=0dec6894&scoped=true&"
import script from "./SimulatorDebugView.vue?vue&type=script&lang=js&"
export * from "./SimulatorDebugView.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorDebugView.vue?vue&type=style&index=0&id=0dec6894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec6894",
  null
  
)

export default component.exports